import { make } from './Inline.gen'
import type { align as Align, alignY as AlignY } from './Inline.gen'

type InlineProps = React.ComponentProps<typeof make>

const Inline = make as React.ForwardRefExoticComponent<
  React.PropsWithoutRef<InlineProps> & React.RefAttributes<HTMLDivElement>
>

export { Inline, type InlineProps, type Align, type AlignY }
